export const API_URL = process.env.REACT_APP_API_URL;

export const REACT_APP_GOOGLE_CLIENT_ID = '852370547494-9kg0igfcuc4ijeft1s7k76qrs7jarlo2.apps.googleusercontent.com'